import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import SearchForm from '../pages/SearchForm.vue'

const routes: RouteRecordRaw[] = [
  { path: '/', component: SearchForm },
  { path: '/en', component: SearchForm },
  { path: '/:pathMatch(.*)*', component: SearchForm },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL as string),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  },
})

export default router
